import { Skeleton } from '@1trading/react';
import { EXCHANGE_STATUS_META } from '@/components/exchange-status-meta';
import { useExchangeStatus } from '@/hooks/queries/exchange/use-exchange-status';

/** Compact site-wide exchange health readout — lives in the top bar, visible on every page. */
export const ExchangeStatusIndicator = () => {
  const { data: status, isPending, isError } = useExchangeStatus();

  if (isPending) return <Skeleton className="h-4 w-24" />;
  // Silently disappearing here would read as "nothing to report" — for exchange health
  // specifically, unavailable is worth saying out loud, not just swallowing.
  if (isError || !status) return <span className="text-sm text-muted-foreground">Exchange status unavailable</span>;

  const meta = EXCHANGE_STATUS_META[status];
  return (
    <span className="flex items-center gap-2 text-sm font-medium whitespace-nowrap">
      <span aria-hidden className={`size-2 rounded-full ${meta.dotClass}`} />
      <span className={meta.textClass}>Exchange {meta.label.toLowerCase()}</span>
    </span>
  );
};
ExchangeStatusIndicator.displayName = 'ExchangeStatusIndicator';
